import { Helmet } from "react-helmet-async";
import { Zap, Target, MessageSquare, FileText, Sparkles, ShieldCheck } from "lucide-react";
import TierPageLayout from "@/components/pricing/TierPageLayout";

const SoloTierPage = () => {
  return (
    <>
      <Helmet>
        <title>Solo Plan — $99/Month | Chat-native Google Ads | Upfixe</title>
        <meta name="description" content="Solo plan: 1 brand, unlimited campaigns, run your whole Google Ads operation from chat. $99/month, 7-day free trial. Founder pricing $49/month for the first 50 customers." />
        <meta name="keywords" content="solo plan, founder Google Ads, MCP server pricing, chat-native google ads" />
        <meta property="og:title" content="Solo Plan — $99/Month | Chat-native Google Ads | Upfixe" />
        <meta property="og:description" content="Solo plan: 1 brand, unlimited campaigns, run your whole Google Ads operation from chat. $99/month, 7-day free trial." />
        <link rel="canonical" href="https://upfixe.com/plans/solo" />
      </Helmet>
      <TierPageLayout
      tierName="Solo"
      tagline="SOLO PLAN"
      headline="Run your Google Ads from chat"
      subheadline="For solo founders who can't justify a PPC agency and don't want to learn the Google Ads UI. Describe your business, describe your campaign, hit publish."
      price={99}
      priceNote="Billed monthly · 7-day free trial · or $990/yr"
      bestFor="Solo founders"
      audienceDescription="Built for the founder running their own SaaS or service business who needs real Google Ads without a $1,000+ retainer."
      features={[
        {
          icon: <MessageSquare className="h-5 w-5" />,
          title: "Chat-native — no dashboards to learn",
          description: "Every action happens in Claude, ChatGPT or Perplexity. No 14-screen wizard, no spreadsheets."
        },
        {
          icon: <Zap className="h-5 w-5" />,
          title: "Unlimited campaigns",
          description: "Draft, edit, and publish as many campaigns as you like. No per-campaign caps."
        },
        {
          icon: <Sparkles className="h-5 w-5" />,
          title: "Value-prop doc built from your homepage",
          description: "Upfixe scrapes your site and writes a 9-section brand brief. Ad copy is informed by who you actually are."
        },
        {
          icon: <Target className="h-5 w-5" />,
          title: "Budget-aware structuring",
          description: "Same prompt, different structure depending on your daily budget. The thing other Google Ads tools don't do."
        },
        {
          icon: <ShieldCheck className="h-5 w-5" />,
          title: "Draft-first publishing",
          description: "Campaigns ship paused. Nothing spends until you flip the switch in the Google Ads UI."
        },
        {
          icon: <FileText className="h-5 w-5" />,
          title: "Performance reporting by chat",
          description: "\"How did we do last week?\" Lifetime and date-ranged metrics, no dashboard to navigate."
        }
      ]}
      limits={[
        "1 brand",
        "Unlimited campaigns & drafts",
        "Unlimited reports",
        "Works in Claude, ChatGPT & Perplexity",
        "Geo targeting (city, region, radius)",
        "Email support from the founder"
      ]}
      useCases={[
        {
          title: "Indie SaaS founders",
          description: "Running your own product. You've got 2 hours a week for marketing — make them count."
        },
        {
          title: "Service business owners",
          description: "Plumber, electrician, consultant. You don't have time to read PPC blog posts. You have time to chat."
        },
        {
          title: "Side-project builders",
          description: "Validating an idea on a real budget. Find out fast whether paid acquisition makes sense."
        },
        {
          title: "Anyone allergic to the Google Ads UI",
          description: "If the campaign creation wizard makes your eyes glaze over, this is for you."
        }
      ]}
      ctaText="Start 7-day free trial"
    />
    </>
  );
};

export default SoloTierPage;
